import React from 'react';
import ReactDOM from 'react-dom';
import Header from '../components/header.jsx'

document.addEventListener('DOMContentLoaded', function() {
    if(document.getElementById('eae-settings') !== null)
    {
        ReactDOM.render(
            <Header/>,document.getElementById('eae-settings'),
        );
    }

});
/*window.addEventListener("load", function() {
    console.log("Everything is loaded");
});*/

